import { useEffect, useState } from "react";

export function LiveClock() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(t);
  }, []);

  const time = now.toLocaleTimeString("de-DE", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const date = now.toLocaleDateString("de-DE", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <div className="rounded-md bg-muted/40 px-3 py-1.5 text-right">
      <div className="font-mono text-base font-medium tabular-nums leading-none">{time}</div>
      <div className="mt-0.5 text-[10px] text-muted-foreground">{date}</div>
    </div>
  );
}
